module.exports = __webpack_public_path__ + "static/media/chicken_toppings.a6da55d3.png";